module.exports = __webpack_public_path__ + "media/images/press_kit/four_seasons_yachts/email/banner-c0284425ac472e95f081c56c366f5fce.jpg";